import * as React from 'react';
import { Button, DatePicker, Table, Pagination } from '@roo/roo';
import dayjs from 'dayjs';
import utils from '@/utils/utils';
import {
    getBillDownLoadList,
    getDownLoadTask,
    IGetBalanceDetail,
    getBillDownLoadListCount,
    CREATE_STATUS,
} from '../../api';
import './index.scss';

function dateFormate(str: string) {
    return str.split('-').join('.');
}

function DownloadBalance() {
    const nowSecondStamp = Math.ceil(+new Date() / 1000);
    const [startTime, setStartTime] = React.useState<number>(
        dayjs('2021-01-01', 'YYYY-MM-DD').unix(),
    ); // 开始时间
    const [endTime, setEndTime] = React.useState<number>(nowSecondStamp - 86400); // 结束时间
    const [dataSource, setDataSource] = React.useState<IGetBalanceDetail[]>([]);
    const [pageCount, setPageCount] = React.useState<number>(0);
    const [pageNo, setPageNo] = React.useState<number>(1);
    const columns: any = [
        {
            prop: 'ctime',
            label: '操作时间',
            align: 'center',
            width: '200px',
            render: (t: string) => {
                const dateObj = utils.timestampToMinutes(Number(t));
                return <span> {`${dateObj.date} ${dateObj.time}`}</span>;
            },
        },
        {
            prop: 'content',
            label: '账单内容',
            align: 'center',
            render: (t: any, row: IGetBalanceDetail) => (
                <span>
                    账单明细 {dateFormate(utils.timestampToMinutes(Number(row.startTimeUnix)).date)}{' '}
                    - {dateFormate(utils.timestampToMinutes(Number(row.endTimeUnix)).date)}
                </span>
            ),
        },
        {
            prop: 'status',
            label: '下载文件',
            align: 'center',
            width: '140px',
            render: (t: any, row: IGetBalanceDetail) =>
                t === CREATE_STATUS.DOING ? (
                    <span>生成中</span>
                ) : (
                    <a href={row.s3Link || ''}>点击下载</a>
                ),
        },
    ];

    function handlePaginationChange(page: number) {
        fetchBillDownLoadList(page);
        BillDownLoadListCount();
    }

    function handleDatePickerClick(value: Array<number>) {
        setStartTime(value[0]);
        setEndTime(value[1]);
    }

    function fetchBillDownLoadList(page: number = pageNo) {
        getBillDownLoadList({ pageNo: page, pageSize: 10 })
            .then(res => {
                if (res.data) {
                    setDataSource(res.data);
                    if (pageNo !== page) {
                        setPageNo(page);
                    }
                }
            })
            .catch(() => {});
    }

    function BillDownLoadListCount() {
        getBillDownLoadListCount()
            .then(res => {
                setPageCount(res.data);
            })
            .catch(() => {});
    }

    function fetchBalanceList() {
        if (!startTime || !endTime) {
            utils.toast('error', '请选择日期');
            return;
        }
        const startTimeV2 = new Date(dayjs.unix(startTime).format('YYYY/MM/DD')).getTime() / 1000;
        const endTimeV2 =
            new Date(dayjs.unix(endTime).format('YYYY/MM/DD')).getTime() / 1000 + 86399;
        getDownLoadTask({
            startTimeUnix: Number(startTimeV2),
            endTimeUnix: Number(endTimeV2),
        })
            .then(res => {
                if (res.code === 0) {
                    fetchBillDownLoadList(1);
                    BillDownLoadListCount();
                }
            })
            .catch(() => {});
    }

    React.useEffect(() => {
        fetchBillDownLoadList();
        BillDownLoadListCount();
    }, []);

    return (
        <div className="download-balance">
            <div className="date-select">
                <span>日期选择：</span>
                <DatePicker.RangePicker
                    clearable
                    valueOfType="second"
                    value={[
                        startTime ? startTime.toString() : '',
                        endTime ? endTime.toString() : '',
                    ]}
                    disabledDate={cur =>
                        +cur > Date.now() - 86400000 || +cur < +dayjs('2021-01-01', 'YYYY-MM-DD')
                    }
                    onChange={handleDatePickerClick}
                />
                <Button className="sarch-button" type="brand" onClick={fetchBalanceList}>
                    下载流水明细
                </Button>
            </div>
            <Table data={dataSource} columns={columns} />
            <Pagination
                total={pageCount}
                pageSize={10}
                currentPage={pageNo}
                onChange={handlePaginationChange}
            />
        </div>
    );
}

export default DownloadBalance;
